module.exports = "/_next/static/images/6b9278f9bbfa42d93146372de446416b-debit-card-magic.png.webp";